<template>
    <router-link :to="link" class="ba b--light-gray flex items-center">
        <img class="w-100" :src="image"/>
    </router-link>
</template>

<script>
export default {
    props: {
        image: {
            type: String
        },
        link: {
            type: String
        }
    }
};
</script>
